import { ReactNode } from "react";
import { useTheme } from "@contexts/ThemeContext";

interface JarvisItemProps {
  label: string;
  value: string | number;
  icon?: ReactNode;
  color?: string;
  className?: string;
}

export default function JarvisItem({ label, value, icon, color, className = "" }: JarvisItemProps) {
  const { colors, mode } = useTheme();

  return (
    <div
      className={`flex items-center justify-between p-4 rounded-xl border transition-all hover:shadow-md ${className}`}
      style={{
        backgroundColor: colors.card,
        borderColor: colors.border,
      }}
    >
      <div className="flex items-center gap-3">
        {icon && (
          <div
            className="p-2 rounded-md"
            style={{
              backgroundColor: color
                ? mode === 'dark'
                  ? `${color}20`
                  : `${color}15`
                : colors.background,
              color: color || colors.text,
            }}
          >
            {icon}
          </div>
        )}
        <span className="text-sm font-medium" style={{ color: colors.textSecondary }}>
          {label}
        </span>
      </div>
      <span
        className="text-2xl font-bold"
        style={{
          color: color || colors.text,
        }}
      >
        {value}
      </span>
    </div>
  );
}
